export default {
  ja: {
    Home: {
      record: 'ベストスコア',
      singlePlayer: '一人で遊ぶ',
      about: 'このサイトについて',
      aboutDescription: 'Geoguess Master は無料で気軽に遊べる地図を使ったゲームです。\
        プレーヤーは5ラウンドでランダムに出された場所の正確な場所を推測して競います。\
        友達と遊ぶ時は最初に部屋を作る人が部屋の名前を決めて部屋を作り、他の人が部屋に入るだけで一緒に遊ぶことができます。',
      limitation: '制限',
      limitationDescription: '地図とストリートビューを表示させるのにお金がかかるため制限をかけています。\
        1日の制限を超えると地図が正しくロードされなくなります。 \
        制限は太平洋標準時での深夜にリセットされます。\
        このサイトはオープンソースなので制限なく遊びたい方は自分でゲームをセットアップすることもできます。',
    },
    StreetViewWithFriends: {
      waitForOtherPlayers: '他のプレーヤーを待っています...',
      redirectToHomePage: 'ホーム画面にリダイレクトします...',
      exitGame: 'ゲームを強制終了しました。5秒後にリダイレクトします...',
      waitForOtherPlayersToFinish: '他のプレーヤーが終了するのを待っています...',
    },
    Maps: {
      makeGuess: '推測する',
      guess: '決定',
      nextRound: '進む',
      viewSummary: '結果を見る',
    },
    MapsWithFriends: {
      makeGuess: '推測する',
      guess: '決定',
      nextRound: '進む',
      viewSummary: '結果を見る',
    },
    Header: {
      language: '言語',
      about: 'このサイトについて',
      limitation: '制限',
      contact: 'お問い合わせ',
    },
    HeaderGame: {
      round: 'ラウンド',
      score: 'スコア',
    },
    CardRoomName: {
      title: '部屋の名前を入力して下さい。',
      next: '進む',
      cancel: 'キャンセル',
    },
    CardRoomPlayerName: {
      title: 'プレーヤーの名前を入力して下さい。',
      next: '進む',
      cancel: 'キャンセル',
    },
    CardRoomSize: {
      title: '部屋の人数を選択して下さい。',
      next: '進む',
      cancel: 'キャンセル',
    },
    CardRoomTime: {
      title: '1ラウンドの制限時間を選択して下さい。',
      next: '進む',
      cancel: 'キャンセル',
      infinite: '無制限',
    },
    DialogRoom: {
      withFriends: '友達と遊ぶ',
      invalidRoomName: '無効な名前です。別の名前を入力して下さい。',
      inProgress: '最初のプレーヤーが部屋を作っています。再度試して下さい。',
      roomIsFull: 'この部屋は既に満員です。',
    },
    DialogSummary: {
      exit: '終了する',
      playAgain: 'もう一度遊ぶ',
    },
    DialogSummaryWithFriends: {
      exit: '終了する',
    },
    Footer: {
      privacyPolicy: 'プライバシーポリシー',
    },
  }
}